import styled from 'styled-components';

import { WHITE, BLACK, BG_GRAY } from '@/styles/variables.style';
import media from '@/styles/media.style';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${WHITE};
`;

export const Container = styled.div`
  width: 100%;

  // スクリーンサイズ (横) が 1440px を超える場合
  &.desktopMedium {
    max-width: 1440px;
    margin: auto;
  }
`;

export const HeadingSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: calc(100% - 40px);
  height: auto;
  max-height: 360px;
  margin: 40px 20px 38px 20px;

  ${media.tabletL`
    height: auto;
    max-height: 400px;
    width: calc(100% - 160px);
    margin: 60px auto 80px 80px;
  `};
`;

export const MainTitle = styled.h1`
  font-size: 28px;
  line-height: 30px;
  text-transform: uppercase;
  color: ${BLACK};

  ${media.tabletL`
    font-size: 48px;
    line-height: 50px;
  `};
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 14px;
  line-height: 16px;
  text-transform: uppercase;
  color: ${BLACK};

  ${media.tabletL`
    font-size: 18px;
    line-height: 20px;
  `};
`;

export const MainTitleWrapper = styled.div`
  width: calc(100% - 40px);
  height: 30px;
  margin-bottom: 65px;
  text-align: center;

  ${media.tabletL`
    width: calc(100% - 160px);
    height: 50px;
    margin-bottom: 100px;
  `};
`;

export const TitleWrapper = styled.div`
  width: calc(100% - 40px);
  height: auto;
  max-height: 180px;
  margin-bottom: 16px;
  text-align: center;

  ${media.tabletL`
    width: calc(100% - 160px);
    height: auto;
    max-height: 240px;
    margin-bottom: 25px;
  `};
`;

export const DescriptionWrapper = styled.div`
  width: 100%;
  height: auto;
  margin-top: 22px;

  ${media.tabletL`
    width: 50%;
    height: auto;
    margin-top: 30px;
  `};
`;

export const Description = styled.p`
  width: 100%;
  height: 100%;
  font-size: 14px;
  text-align: center;
  color: ${BLACK};

  ${media.tabletL`
    font-size: 18px;
  `};
`;

export const ImagesSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 100px;

  ${media.tabletL`
    flex-direction: row;
    margin-bottom: 120px;
  `};
`;

export const Image = styled.img`
  width: 100%;
  margin-bottom: 45px;

  ${media.tabletL`
    margin-bottom: 37px;
  `};
`;

export const ImageWrapper = styled.div`
  &.hairDiagnosis {
    margin: 0 0 60px;
    text-align: center;

    ${media.tabletL`
      width: 512px;
      margin: 0 30px 0 0;
    `};
  }

  &.colorSimulator {
    margin: 0;
    text-align: center;

    ${media.tabletL`
      width: 512px;
      height: 100%;
      min-height: 630px;
      margin: 0px;
    `};
  }
`;

export const HeroImageCatchCopy = styled.p`
  margin-top: 20px;
  font-size: 14px;
  line-height: 16px;
  color: ${BLACK};

  ${media.tabletL`
    font-size: 18px;
    line-height: 20px;
  `};
`;

export const HeroImageTitle = styled.h3`
  margin: 10px 0 23px;
  font-size: 24px;
  line-height: 26px;
  color: ${BLACK};

  ${media.tabletL`
    margin: 15px 0 35px;
    font-size: 36px;
    line-height: 38px;
  `};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;

  ${media.tabletL`
    justify-content: left;
  `};
`;

export const Button = styled.button`
  width: 220px;
  height: 48px;
  text-transform: uppercase;
  color: ${WHITE};
  background: ${BLACK};
  border: none;
  font-size: 12px;
  padding: 0;
  outline: none;
  cursor: pointer;

  ${media.tabletL`
    width: 338px;
    height: 72px;
    margin-bottom: 0;
    font-size: 14px;
  `};
`;

export const Linker = styled.a`
  text-decoration: none;

  &:focus {
    outline: 0;
  }

  &.termsAndPolicy {
    text-decoration: none;
    outline: 0;
  }
`;

export const PlaceholderWrapper = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction || 'column'};
  width: 100%;

  ${media.tabletL`
    flex-direction: ${({ direction }) => direction || 'row'};
  `};

  &.image {
    width: unset;

    ${media.tabletL`
      width: 512px;
      margin-right: ${({ marginRight }) => marginRight};
    `};
  }

  &.terms {
    justify-content: center;
  }

  &.contentPlaceholder {
    flex-direction: column;
    justify-content: center;
    margin: 0 0 20px;
    order: ${({ left }) => (left ? '-1' : '0')};

    ${media.tabletL`
      width: calc(50% - 90px);
      margin: ${({ left }) => (left ? '0 20px 80px 90px' : '0 90px 80px 20px')};
      order: ${({ left }) => (left ? '0' : '-1')};

      &.isLast {
        margin: ${({ left }) => (left ? '0 20px 0 90px' : '0 90px 0 20px')};
      }
    `};
  }

  &.contentImagePlaceholder {
    width: 100%;
    height: 251px;
    padding: 0 20px;
    order: ${({ left }) => (left ? '-1' : '0')};

    ${media.tabletL`
      width: 50%;
      height: 540px;
      margin-bottom: 80px;
      padding: 0;

      &.isLast {
        margin-bottom: 0;
      }
    `};
  }

  &.contentPlaceholderChild {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: ${({ spContentPlaceholderHeight, spButtonPlaceholderHeight }) =>
      spContentPlaceholderHeight || spButtonPlaceholderHeight};
    margin-right: 20px;

    ${media.tabletL`
      align-items: flex-start;
      margin-right: 0;
    `};
  }
`;

export const TermsAndPolicyWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 30px;
  color: ${BLACK};
  text-transform: uppercase;
  text-decoration: underline;

  ${media.tabletL`
    font-size: 14px;
  `};
`;

export const TermsAndPolicy = styled.div`
  text-align: right;
  color: ${BLACK};
  font-size: 12px;
  padding-right: ${({ paddingRight }) => paddingRight}px;
  text-transform: uppercase;

  ${media.tabletL`
    font-size: 14px;
  `};
`;

export const NoteWrapper = styled.div`
  width: calc(100% - 40px);
  margin: 30px 20px 0;
  text-align: left;

  ${media.tabletL`
    width: auto;
    margin: 30px 0 0;
  `};
`;

export const Note = styled.div`
  color: ${BLACK};
  text-align: left;
  font-size: 10px;
`;

export const ContentsSection = styled.section`
  width: 100%;
  height: auto;
  margin-bottom: 65px;

  div:nth-last-child {
    margin-bottom: 0;
  }

  ${media.tabletL`
    width: 100%;
    margin-bottom: 90px;
  `};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 60px;

  ${media.tabletL`
    flex-direction: row;
    width: 100%;
    margin-bottom: 80px;
  `};
`;

export const ContentImageWrapper = styled.div`
  width: calc(100% - 40px);
  margin-bottom: 20px;

  ${media.tabletL`
    width: 50%;
    margin-bottom: 0;
    order: ${({ left }) => (left ? '-1' : '0')};
  `};
`;

export const ContentTextButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: calc(100% - 40px);

  ${media.tabletL`
    width: 50%;
    align-items: flex-start;
    padding-right: ${({ left }) => (left ? '20px' : '90px')};
    padding-left: ${({ left }) => (left ? '90px' : '20px')};
    order: ${({ left }) => (left ? '0' : '-1')};
  `};

  &.desktopMedium {
    padding-right: ${({ left }) => (left ? '0' : '90px')};
    padding-left: ${({ left }) => (left ? '90px' : '0')};
  }
`;

export const ContentTextButtonContent = styled.div`
  width: 100%;
`;

export const ContentTitle = styled.div`
  width: 100%;
  margin: 0 0 20px;
  color: ${BLACK};
  font-size: 24px;
  text-align: left;

  ${media.tabletL`
    margin: ${({ left }) => (left ? '0 0 20px 0' : '0 90px 20px 0')};
    font-size: 30px;
  `};
`;

export const ContentDescription = styled.div`
  width: 100%;
  margin: 0 0 30px;
  text-align: left;

  ${media.tabletL`
    margin: ${({ left }) => (left ? '0 0 42px 0' : '0 90px 42px 0')};
  `};
`;

export const ContentDescriptionMarkdownLine = styled.div`
  > p {
    color: ${BLACK};
    font-size: 14px;
    word-wrap: break-word;

    ${media.tabletL`
      font-size: 18px;
    `};
  }
`;

export const SalonLocatorSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: auto;
  margin-bottom: 30px;
  padding: 60px 20px;
  background: ${BG_GRAY.COMMON_1};

  ${media.tabletL`
    height: auto;
    margin-bottom: 40px;
    padding: 32px 0 60px;
  `};
`;

export const SalonLocatorButtonWrapper = styled.div`
  margin: 0;
`;

export const SalonLocatorMarkdownWrapper = styled.div`
  margin-bottom: 30px;

  ${media.tabletL`
    margin-bottom: 68px;
  `};
`;

export const NoteMarkdownLine = styled.div`
  > p {
    display: block;
    color: ${BLACK};
    text-align: left;
    margin: 0;
    font-size: 14px;
    line-height: 16px;

    ${media.tabletL`
      font-size: 10px;
      line-height: 20px;
    `};
  }
`;

export const SalonLocatorMarkdownLine = styled.div`
  > p {
    display: block;
    color: ${BLACK};
    text-align: center;
    margin: 0;
    font-size: 14px;
    line-height: 16px;

    ${media.tabletL`
      font-size: 18px;
      line-height: 28px;
    `};
  }
`;

export const Hr = styled.div`
  width: 40px;
  height: 2px;
  background: ${BLACK};
`;



// WEBPACK FOOTER //
// ./src/pages/HairDiagnosis/HairDiagnosisPage/HairDiagnosisPage.style.js